import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { appService } from "@/services/app.service";
import TokenService from "@/services/token.service";
import { CampaignService } from "@/services/campaign.service";
import router from "@/router";

import "@/assets/css/icon-moon.css";
import "@/assets/css/app.css";

import GoogleAnalytics from "@/components/GoogleAnalytics.vue";
import ChatBot from "@/components/ChatBot.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const _appService = appService();

const currentCulture = computed(() => {
  const culture = route.params.culture;

  if (typeof culture === "string" && culture.toLowerCase() === "en") {
    return "en";
  }

  return "tr";
});

watch(
  currentCulture,
  (culture) => {
    _appService.syncLanguageResources(culture);
  },
  { immediate: true }
);
const isProduction = window.location.hostname === "www.delphinpiraye.com";

const setCookie = (name: string, value: string, years: number) => {
  const date = new Date();
  date.setTime(date.getTime() + years * 365 * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();
  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; Secure; SameSite=Lax";
};

const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

onMounted(() => {
  const user = TokenService.getUser();
  if (user && user.accessToken && user.accessToken.token) {
    const isSpecialOffersPage =
      window.location.pathname.endsWith("/ozel-firsatlar");
    const isLogoutPage = window.location.pathname.endsWith("/logout");

    if (!isSpecialOffersPage && !isLogoutPage) {
      CampaignService.checkAndShowOffer({
        culture: currentCulture.value,
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    isProduction
      ? (_openBlock(), _createBlock(GoogleAnalytics, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _createVNode(ChatBot, {
      mode: "floating",
      title: "Delphin"
    })
  ], 64))
}
}

})